var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"timeline-wrapper"},[_c('div',[_c('Timeline',{ref:"scheduler",attrs:{"groups":_vm.employeesByPhase,"items":_vm.workDaysByEmployee,"options":_vm.timelineOption},on:{"click":_vm.onSingleClick,"double-click":_vm.dbClick,"mouse-down":_vm.mouseMove}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }